import React, { useState, useEffect } from 'react';

import { MTable } from 'ui/mtable/MTable';
import { isResellerLike } from 'utils/user';

import { withAppContext } from '../../../AppContext';
import { loadBillings } from '../services';
import { GroupByFilter } from './components/table/CountsFilters';

function Counts({ app }) {
    const { currentUser } = app;

    const [state, setState] = useState({
        billings: [],
        grouped: [],
        loading: true,
        groupByName: 'company',
    });

    useEffect(() => {
        loadBillings().then(billings => {
            updateState({
                billings,
                grouped: processBilling(billings, state.groupByName),
                loading: false,
            });
        });
    }, []);

    const updateState = values => setState({ ...state, ...values });

    const onFilterAction = ({ name, payload }) => {
        if (name === 'change') {
            const groupByName = payload.name;
            updateState({
                groupByName,
                grouped: processBilling(state.billings, groupByName),
            });
        }
    };
    const filters = isResellerLike(currentUser)
        ? [
              () => (
                  <GroupByFilter
                      value={state.groupByName}
                      onAction={onFilterAction}
                  />
              ),
          ]
        : [];

    return (
        <MTable
            key={state.groupByName}
            columns={preapreColumns(state.groupByName)}
            data={state.grouped}
            loading={state.loading}
            searchPlaceholder="Find companies"
            stateKey="Counts"
            primaryFilters={filters}
        />
    );
}

const processBilling = (billings, type) => {
    if (type === 'billing_company') {
        return groupBillings(billings);
    }
    return billings;
};

const groupBillings = billings => {
    const columnsGroups = ['billing_company', 'subscription', 'invoice_date'];
    const groups = multiGroupBy(billings, columnsGroups);
    return sumarizeGroups(groups);
};

const sumarizeGroups = data => {
    const result = [];
    for (const rows of Object.values(data)) {
        const node = { ...rows[0], users_count: 0 };
        for (const row of rows) {
            node.users_count += row.users_count;
        }
        result.push(node);
    }
    return result;
};

const multiGroupBy = (data, columns) => {
    const result = {};
    for (const row of data) {
        const key = columns.map(column => row[column]).join('.');
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(row);
    }
    return result;
};

const getColumns = () => [
    {
        field: 'uuid',
        title: 'Uuid',
        notFilter: true,
        hidden: true,
        export: false,
    },
    {
        field: 'company_name',
        title: 'Company',
        cellStyle: {
            width: '20%',
        },
    },
    {
        field: 'billing_company_name',
        title: 'Billing Company',
        cellStyle: {
            width: '20%',
        },
    },
    {
        field: 'billing_company_type',
        title: 'Type',
        cellStyle: {
            width: '15%',
        },
    },
    {
        field: 'type',
        title: 'Type',
        filterType: 'select',
        cellStyle: {
            width: '15%',
        },
    },
    {
        field: 'subscription',
        title: 'Subscription',
        filterType: 'select',
        cellStyle: {
            width: '15%',
        },
    },
    {
        field: 'invoice_date',
        title: 'Invoice Date',
        cellStyle: {
            width: '15%',
        },
    },
    {
        field: 'users_count',
        title: 'Users',
        cellStyle: {
            width: '15%',
        },
    },
];

const COLUMNS = {
    billing_company: {
        columns: [
            'uuid',
            'billing_company_name',
            'billing_company_type',
            'subscription',
            'invoice_date',
            'users_count',
        ],
        sort: {
            name: 'billing_company_name',
            order: 'desc    ',
        },
    },
    company: {
        columns: [
            'uuid',
            'company_name',
            'billing_company_name',
            'type',
            'subscription',
            'invoice_date',
            'users_count',
        ],
        sort: {
            name: 'users_count',
            order: 'desc',
        },
    },
};

const isVisibleColumn = (config, column) =>
    config.columns === '*' || config.columns.includes(column.field);

const preapreColumns = type => {
    const config = COLUMNS[type];
    if (config) {
        return getColumns().reduce((columns, column) => {
            if (isVisibleColumn(config, column)) {
                if (config.sort && config.sort.name === column.field) {
                    column.defaultSort = config.sort.order;
                }
                columns.push(column);
            }
            return columns;
        }, []);
    }
    return [];
};

export default withAppContext(Counts);
